/**
 * Limiares de consumo do armazenamento local (RN-105).
 *
 * São regra de negócio, não detalhe de infraestrutura: definem quando o sistema avisa o
 * usuário e quando recusa novos anexos. Ficam no domínio para que a mesma constante
 * governe o aviso na tela e a recusa no caso de uso.
 */

/** A partir daqui a interface alerta o usuário. */
export const STORAGE_WARN_RATIO = 0.8;

/** A partir daqui novos uploads são recusados, com orientação de como liberar espaço. */
export const STORAGE_BLOCK_RATIO = 0.95;

export type StoragePressure = 'ok' | 'warn' | 'block';

export function storagePressure(usedRatio: number): StoragePressure {
  if (usedRatio >= STORAGE_BLOCK_RATIO) return 'block';
  if (usedRatio >= STORAGE_WARN_RATIO) return 'warn';
  return 'ok';
}
